import { useJsApiLoader } from '@react-google-maps/api';

const useGoogleMapLoad = () => {
  const { isLoaded: isGoogleMapLoad } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyCu3pQ2rxalRAWIONNcxoYST8Cy7NJrveA',
    libraries: ['geometry', 'drawing', 'places'],
  });

  return [isGoogleMapLoad];
};

export default useGoogleMapLoad;
